import { Capacitor, PluginListenerHandle, registerPlugin } from '@capacitor/core';

// Нативний плагін дзвінків у закритий застосунок (етап 2):
// iOS — VaillantBridgeViewController.swift (PushKit + CallKit), Android — VoipCallPlugin.java (FCM + екран дзвінка)
export interface VoipCallPlugin {
  getToken(): Promise<{ platform: 'ios' | 'android'; token: string }>;
  getPendingAnswer(): Promise<{ channelId?: string }>;
  // answeredElsewhere — відповів колега (iOS: у «Недавніх» не пропущений)
  endCall(options: { channelId?: string; answeredElsewhere?: boolean }): Promise<void>;
  // «Недавні»: iOS — розмова застосунку як дзвінок CallKit; Android — запис у журнал викликів після розмови
  startCall(options: { callId: string; number: string; name: string; incoming: boolean }): Promise<void>;
  reportConnected(options: { callId: string }): Promise<void>;
  logCall(options: { number: string; name: string; incoming: boolean; startedAt: number; duration: number }): Promise<void>;
  requestCallLogPermission(): Promise<void>;
  // Android 14+: дозвіл показувати екран дзвінка на заблокованому телефоні (лише Android)
  canUseFullScreenIntent(): Promise<{ granted: boolean }>;
  openFullScreenIntentSettings(): Promise<void>;
  addListener(event: 'token', listener: (data: { platform: 'ios' | 'android'; token: string }) => void): Promise<PluginListenerHandle>;
  addListener(event: 'callIncoming' | 'callAnswered' | 'callEnded', listener: (data: { channelId: string }) => void): Promise<PluginListenerHandle>;
}

export const VoipCall = registerPlugin<VoipCallPlugin>('VoipCall');

// у старих збірках зі стору плагіна ще немає
export const isVoipCallAvailable = () => Capacitor.isPluginAvailable('VoipCall');
